import { useEffect, useState } from "react";
import { TableShared } from "../../../../shared";
import { char, number } from "../../../../utils";
import { Message, useToaster } from "rsuite";
import { appCRUD } from "../../../../actions/app";

export const StudyYear = (props) => {
    const { dataId } = props;
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [page, setPage] = useState(1);
    const [count, setCount] = useState(0);
    const [postsPerPage, setePostPerPage] = useState(10);
    const [nextPage, setNextPage] = useState(0);
    const [value, setValue] = useState("");
    const [index, setIndex] = useState(0);
    const toaster = useToaster();

    useEffect(() => {
      setLoading(true);
      setTimeout(() => {
        appCRUD
          .loadStudentStudy(postsPerPage, nextPage, dataId, value, "id")
          .then((resp) => {
            setData(resp.data.results);
            setCount(resp.data.count);
          })
          .catch((error) => {
            toaster.push(
              <Message type="error" showIcon header={"Error"} closable>
                <p className="h6">
                  <p className="fw-bold fs-14">Oooh Sorry...!</p>
                  <p className="text-dark fs-12">{error}.</p>
                </p>
              </Message>,
              { placement: "topEnd", duration: 7000 }
            );
          })
          .finally(() => {
            setLoading(false);
          });
      }, 500);
    }, [page, postsPerPage, value, index, nextPage, dataId]);

     const defaultColumns = [
       {
         key: "sn",
         title: "#",
         dataIndex: "sn",
         fixed: true,
         width: 60,
       },
       {
         key: "academic",
         title: "Academic Year",
         dataIndex: "academic",
         sortable: true,
         flexGrow: 1,
       },
       {
         key: "year",
         title: "Year",
         dataIndex: "year",
         sortable: true,
         flexGrow: 1,
       },
       {
         key: "status",
         title: "Status",
         dataIndex: "status",
         sortable: true,
         flexGrow: 1,
       },
     ];

     const dataItem = data?.map((dt, i) => ({
       id: dt.id,
       sn: i + 1,
       academic: dt.academic_year ? dt.academic_year.name : "N/A",
       year: dt.study_year ? number.fNumber(dt.study_year) : "N/A",
       status: dt.is_active ? (
         <span class="badge badge-soft-success badge-border fs-11">
           {char.toTitleCase("active")}
         </span>
       ) : (
         <span class="badge badge-soft-danger badge-border fs-11">
           {char.toTitleCase("inactive")}
         </span>
       ),
     }));
  

    return (
      <>
        <TableShared
          setOpen={null}
          loading={loading}
          data={dataItem}
          setData={setData}
          page={page}
          setPage={setPage}
          count={count}
          postsPerPage={postsPerPage}
          setePostPerPage={setePostPerPage}
          setNextPage={setNextPage}
          value={value}
          setValue={setValue}
          defaultColumns={defaultColumns}
          button={null}
          link={"#"}
          showButton={true}
          setLoading={setLoading}
        />
      </>
    );

}